import { Center, Stack, Text } from '@mantine/core'
import type { JSX } from 'react'
import { useNavigate } from 'react-router'
import { CreateCarePlanButton } from '#src/components/care-plan/CreateCarePlanButton.tsx'
import { useCurrentParticipant } from '#src/contexts/current-participant/useCurrentParticipant.ts'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

export function NoCarePlan(): JSX.Element {
  const navigate = useNavigate()
  const participant = useCurrentParticipant()
  const isReadOnly = useIsReadOnly()

  return (
    <Center className="size-full">
      <Stack align="center">
        <Text size="xl" className="font-bold">
          No care plan has been created yet for this participant
        </Text>
        {!isReadOnly && (
          <CreateCarePlanButton
            participant={participant.reference}
            onCreated={(carePlanId) => {
              void navigate(
                `/Patient/${participant.id}/care-plans/${carePlanId}`
              )
            }}
          />
        )}
      </Stack>
    </Center>
  )
}
